import request from "../utils/request";
import {message} from "antd";


export async function addMember(params, form) {

  const res = await request({
    url: "/sys_user/create",
    method: "post",
    data: params, // 将 params 作为请求体传递
  });

  console.log("res:", res)
  if (res.code === 0) {
    form.resetFields();
    message.success('用户已添加!');
  } else {
    message.error('用户添加失败, '+ res.info);
  }
  return res;
}

export async function changeMemberStatus(userNo, status) {
  const res = await request({
    url: "/sys_user/modify_status?user_no=" + userNo + "&status=" + status,
    method: "get",
  });

  console.log("res:", res);

  return res;
}

export async function deleteMember(userNo) {
  const res = await request({
    url: "/sys_user/delete?user_no=" + userNo,
    method: "get",
  });
  console.log("res:", res);
  return res;
}

export async function updateMember(userNo, nickName, phoneNo, roleId) {
  const res = await request({
    url: "/sys_user/update?user_no=" + userNo + "&nick_name=" + nickName + "&phone_no=" + phoneNo + "&role_id=" + roleId,
    method: "get",
  });

  console.log("res:", res);
  return res;
}

export async function fetchMembers(pageNo, pageSize, nick_name, phone_no, user_no, roleId, status, startTime, endTime) {
  const res = await request({
    url: "/sys_user/list?page_no=" + pageNo + "&page_size=" + pageSize + "&nick_name=" + nick_name +
        "&phone_no=" + phone_no + "&user_no=" + user_no + "&role_id=" + roleId
    + "&status=" + status + "&start_time=" + startTime + "&end_time=" + endTime,
    method: "get",
  });

  console.log("fetchMembers res:", res);

  return res;
}



